import firebase from './firebase';

import 'firebase/auth';

const auth = firebase.auth();

export { auth as default };
